export function defer(deferredFunction: () => unknown) {
  window.setTimeout(deferredFunction, 0)
}
